import type { RouteRecordRaw } from 'vue-router';
import { FEATURE_FLAGS } from '@AuthModule';

// NOTE :: Open to every staff user of a shelter with saved reports on; managing templates is checked inside the page.
export default <RouteRecordRaw[]>[
  {
    path: 'shared-reports',
    name: 'shared-reports',
    component: () => import('./views/ReportTemplates.view.vue'),
    meta: {
      featureFlag: FEATURE_FLAGS.SAVED_REPORTS,
    },
  },
];
